// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"toolbar--3B0ehzkvdJ","light":"light--2MguJ0hCSG","dark":"dark--2Ia54RwWMI","controls":"controls--14QNooAe47"};